import { getFilenameFromHeader } from '../../utils/get-filename-header'
import { getAPIUrl } from '../API'

export const downloadFile: (
  path: string,
  reportId: string,
  reportTypeId: number,
) => Promise<DownloadFileResult | null> = async (
  path: string,
  reportId: string,
  reportTypeId: number,
) => {
  const res = await fetch(getAPIUrl() + path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId,
      reportType: reportTypeId,
    }),
  })
  if (res.status === 200) {
    const filename = getFilenameFromHeader(
      res.headers.get('Content-Disposition'),
    )
    const blob = await res.blob()
    return {
      filename,
      blob,
    }
  }
  return null
}

export type DownloadFileResult = {
  filename: string
  blob: Blob
}

export const onDownloadSuccess = (result: DownloadFileResult | null) => {
  if (!result) return
  const href = window.URL.createObjectURL(result.blob)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', result.filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
